// Operator details shown in the footer, legal pages and cookie notice. Edit here only:
// every page and every policy reads these values (policies use {{TOKENS}} replaced at render).
export const SITE = {
  product: 'Corridor Intelligence',
  operator: 'SubsidyBazaar', // registered legal name of the operating entity — confirm before launch
  contactEmail: 'hello@subsidybazaar.com',
  whatsappNumber: '9490030441',
  whatsappIntl: '919490030441',
  whatsappDisplay: '+91 94900 30441',
  grievanceOfficer: 'Grievance Officer', // replace with the named officer (IT Rules 2011, rule 5(9))
  grievanceEmail: 'hello@subsidybazaar.com',
  website: 'ausindia.subsidybazaar.com',
  jurisdiction: 'India',
  policiesUpdated: '18 October 2026',
} as const;

export function getWhatsAppHelplineUrl(role?: string | null, customContext?: string): string {
  const isBuyer = role === 'buyer';
  const isSeller = role === 'seller';
  const rolePrefix = isBuyer
    ? 'Hello, I am a Buyer on the platform and have a question.'
    : isSeller
    ? 'Hello, I am a Seller on the platform and have a question.'
    : 'Hello, I have a question regarding the platform.';

  const message = customContext ? `${rolePrefix} ${customContext}` : rolePrefix;
  return `https://wa.me/${SITE.whatsappIntl}?text=${encodeURIComponent(message)}`;
}

export const COPYRIGHT_YEAR = new Date().getFullYear();

export type LegalDoc = 'terms' | 'privacy' | 'data-policy' | 'cookies';

export const LEGAL_DOCS: { id: LegalDoc; title: string }[] = [
  { id: 'terms', title: 'Terms & Conditions' },
  { id: 'privacy', title: 'Privacy Policy' },
  { id: 'data-policy', title: 'Data Policy' },
  { id: 'cookies', title: 'Cookie Policy' },
];

/** Fill {{TOKENS}} in policy text from SITE. Unknown tokens are left visible so they get noticed. */
export function fillTokens(text: string): string {
  const values: Record<string, string> = {
    PRODUCT: SITE.product,
    OPERATOR: SITE.operator,
    EMAIL: SITE.contactEmail,
    GRIEVANCE_NAME: SITE.grievanceOfficer,
    GRIEVANCE_EMAIL: SITE.grievanceEmail,
    WEBSITE: SITE.website,
    JURISDICTION: SITE.jurisdiction,
    UPDATED: SITE.policiesUpdated,
  };
  return text.replace(/\{\{([A-Z_]+)\}\}/g, (m, k: string) => values[k] ?? m);
}
